import ListItemPhoto from './ListItemPhoto'

import type { TAPIInspiration } from 'types/inspirations'
import type { FC } from 'react'

export interface ListItemContainerProps {
  containerClassName: string
  isDesktop?: boolean
}
interface ListItemProps
  extends React.HTMLAttributes<HTMLAnchorElement>,
    ListItemContainerProps {
  data: TAPIInspiration
}

const ListItem: FC<ListItemProps> = ({ data, ...props }) => {
  return <ListItemPhoto data={data} {...props} />
}
export default ListItem
